import React, { FC, useMemo } from 'react'

import Container from '@Components/CMS/Container'
import { Link, LinkColor, LinkProps } from '@Components/CMS/Link'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue, getLinkFieldValue } from '@Globals/CMS/FieldHelpers'

const allowedLinkColors: LinkColor[] = ['primary', 'dark', 'white']

const sanitizeLinkColor = (color: LinkColor | 'none'): LinkColor => ((allowedLinkColors.indexOf(color as LinkColor) < 0) ? 'primary' : color as LinkColor)

const getBlockData = (linkBlock: Block): LinkProps => {
  const link = getLinkFieldValue(linkBlock.fields || [], 'link')

  return {
    color: sanitizeLinkColor(getJSONFieldValue(linkBlock.fields || [], 'color') || 'none'),
    newTab: getJSONFieldValue(linkBlock.fields || [], 'newTab') || false,
    text: getJSONFieldValue(linkBlock.fields || [], 'text') || '',
    url: link?.url || '',
  }
}

interface LinkBlockProps {
  id?: string
  linkBlock: Block
}

const LinkBlock: FC<LinkBlockProps> = ({ id, linkBlock }) => {
  const {
    color,
    newTab,
    text,
    url,
  } = useMemo(() => getBlockData(linkBlock), [linkBlock])

  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <Container><Link color={color} id={id} newTab={newTab} text={text} url={url} /></Container>
}

export default LinkBlock
